"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.emailVeriErrMsgObj = void 0;
const i18next_1 = __importDefault(require("i18next"));
const errors_1 = require("@/common/errors");
exports.emailVeriErrMsgObj = {
    pattern: () => i18next_1.default.t('올바른 형식의 이메일을 입력해주세요'),
    expired: () => i18next_1.default.t('인증번호가 만료되었어요. 재발송으로 다시 받아주세요!'),
    noMatch: () => i18next_1.default.t('인증번호가 일치하지 않아요. 다시 입력해주세요!'),
    duplicated: () => i18next_1.default.t('이미 가입된 이메일이에요'),
};
function default_1(error, setError) {
    var _a, _b;
    const errorCode = (_b = (_a = error.response.data) === null || _a === void 0 ? void 0 : _a.meta) === null || _b === void 0 ? void 0 : _b.alert_type;
    switch (errorCode) {
        case 40000: // ? pattern
            setError('email', { type: '40000', message: exports.emailVeriErrMsgObj.pattern() }, { shouldFocus: true });
            break;
        case 40001: // ? expired
            setError('veriCode', { type: '40001', message: exports.emailVeriErrMsgObj.expired() });
            break;
        case 40002: // ? noMatch
            setError('veriCode', { type: '40002', message: exports.emailVeriErrMsgObj.noMatch() }, { shouldFocus: true });
            break;
        case 40003: // ! [unexpected] 인증받은 이메일과 다른 이메일
            alert('인증한 이메일이 아닙니다!');
            window.location.reload();
            break;
        case 40004: // ? duplicated
            setError('email', { type: '40004', message: exports.emailVeriErrMsgObj.duplicated() }, { shouldFocus: true });
            break;
        default:
            alert((0, errors_1.commonErrorMsg)());
    }
}
exports.default = default_1;
